import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserPropertiesForDashboardQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.User_Properties_Bool_Exp>;
}>;


export type GetUserPropertiesForDashboardQuery = { __typename?: 'query_root', user_properties: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, partition_id?: string | null, organization_id: any, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null } | null, property_documents: Array<{ __typename?: 'property_documents', id: any, name?: string | null, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, type?: string | null, description?: string | null, doctrine_doc_id?: string | null, created_at?: any | null }>, installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, device_status?: string | null, product: { __typename?: 'products', id: any, name: string, product_category: { __typename?: 'product_categories', name: string, label: string } } }> } | null }> };


export const GetUserPropertiesForDashboardDocument = gql`
    query getUserPropertiesForDashboard($where: user_properties_bool_exp) {
  user_properties(where: $where, order_by: {property: {name: asc}}) {
    id
    user_id
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      photo_link
      partition_id
      organization_id
      organization {
        id
        name
        contact_name
        email
        type
      }
      property_documents {
        id
        name
        photo_link
        document_link
        video_link
        audio_link
        site_link
        transcription
        transcribed
        type
        description
        doctrine_doc_id
        created_at
      }
      installed_products(where: {deleted_at: {_is_null: true}}) {
        id
        product_id
        property_id
        product {
          id
          name
          product_category {
            name
            label
          }
        }
        device_status
      }
    }
  }
}
    `;

/**
 * __useGetUserPropertiesForDashboardQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesForDashboardQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserPropertiesForDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>(GetUserPropertiesForDashboardDocument, options);
      }
export function useGetUserPropertiesForDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>(GetUserPropertiesForDashboardDocument, options);
        }
export function useGetUserPropertiesForDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>(GetUserPropertiesForDashboardDocument, options);
        }
export type GetUserPropertiesForDashboardQueryHookResult = ReturnType<typeof useGetUserPropertiesForDashboardQuery>;
export type GetUserPropertiesForDashboardLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesForDashboardLazyQuery>;
export type GetUserPropertiesForDashboardSuspenseQueryHookResult = ReturnType<typeof useGetUserPropertiesForDashboardSuspenseQuery>;
export type GetUserPropertiesForDashboardQueryResult = Apollo.QueryResult<GetUserPropertiesForDashboardQuery, GetUserPropertiesForDashboardQueryVariables>;